import React from 'react';
import { SummaryPanelContainer, SummaryPanelRow } from '@css-xp/base';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';

type AdditionalStatuspageDetailsProps = {
  entitlement: EntitlementDetails;
  isDesignIteration1Enabled?: boolean;
};

export const AdditionalStatuspageDetails: React.FC<AdditionalStatuspageDetailsProps> = ({
  entitlement,
  isDesignIteration1Enabled,
}) => {
  return (
    <SummaryPanelContainer title={'Additional information'} version={isDesignIteration1Enabled ? 2 : undefined}>
      <SummaryPanelRow
        label="Page URL"
        value={entitlement.cloudSiteCustomHostname}
        useWrapper={isDesignIteration1Enabled}
      />
    </SummaryPanelContainer>
  );
};
